/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { MultiSelect, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import AuditRepository from '../../../helpers/api/AuditRepository';

export default class ProcessMultiSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: [],
      selectedItems: [],
    };
    this.onChange = this.onChange.bind(this);
    this.repository = new AuditRepository();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const items = await this.getItems();
    this.setState({ items, selectedItems: this.props.initialSelectedItems, loading: false });
  }

  onChange = (selectedItem) => {
    const items = selectedItem ? selectedItem.selectedItems : null;
    this.setState({
      selectedItems: items,
    });
    this.props.onChange(items);
  };

  getItems = async () => {
    let items = [];
    try {
      items = await this.repository.getProcesses();
    } catch (error) {
        console.error(error);
      this.props.onError(error);
    }
    return items;
  };

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <MultiSelect.Filterable
        id="auditProcessSelect"
        name="auditProcessSelect"
        invalid={this.props.invalid}
        invalidText={this.props.invalidText}
        disabled={this.state.items < 1 || this.props.disabled}
        placeholder={
          this.state.selectedItems < 1
            ? 'Choose one or more process'
            : this.state.selectedItems.map((elem) => elem.name).join(', ')
        }
        itemToString={(item) => (item ? item && item.name : '')}
        items={this.state.items}
        light={false}
        onChange={this.onChange}
        type="default"
        initialSelectedItems={this.props.initialSelectedItems}
      />
    );
  }
}

ProcessMultiSelect.propTypes = {
  invalid: PropTypes.bool,
  invalidText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  initialSelectedItems: PropTypes.array,
  disabled: PropTypes.bool,
};
ProcessMultiSelect.defaultProps = {
  invalid: false,
  invalidText: '',
  initialSelectedItems: [],
  disabled: true,
};
